



























import {Component, Vue} from 'vue-property-decorator'

@Component({
  name: 'shot-add-fab-button',
})
export default class ShotAddFabButton extends Vue {
  fab = false
}
